import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col} from 'react-bootstrap';
import config from '../config';
import Loading from '../components/loading';

const {apiUrl} = config;

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: !this.props.name,
      // name: 'Fashion of cars'
      name: this.props.name
    };
  }

  componentDidMount() {
    const {name} = this.state;
    if (!name) {
      this.fetch();
    }
  }

  fetch = () => {
    const {_id} = this.props;
    fetch(`${apiUrl}/coins/${_id}`)
      .then(resp => {
        return resp.json();
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          name: resp.name
        });
      });
  }

  render() {
    const {isLoading} = this.state;
    if (isLoading) {
      return (
        <Row>
          <Col sm={8} smOffset={2} className="text-center">
            <Loading />
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col sm={8} smOffset={2}>
          <h3>Thank you for registering {this.state.name}!</h3>
          <p>To finish the registration, please click on the confirmation link you will get shortly as an email.</p>
        </Col>
      </Row>
    );
  }
}

Confirmation.propTypes = {
  name: PropTypes.string,
  _id: PropTypes.string.isRequired
};
export default Confirmation;



// WEBPACK FOOTER //
// ./src/register/confirmation.js